import React from 'react';
import Link from "react-router-dom/es/Link";

export default class ForbiddenAccess extends React.Component {
    render() {
        return (
            <div>

                <div>
                    <h1 style={{'textAlign': 'center'}}>Nu sunteti autorizat. Va rog sa va autentificati</h1>
                </div>

                <div style={{'textAlign': 'center', marginTop: '20px' }}>
                    <Link  to='/logout'>Catre login</Link>
                </div>
            </div>
        )
    }

};